import { supabase } from '../lib/supabase';

export const auditService = {
  /**
   * Get audit logs with pagination and filters
   */
  async getAuditLogs({
    page = 1,
    pageSize = 50,
    action = null,
    tableName = null,
    userId = null,
    startDate = null,
    endDate = null
  } = {}) {
    try {
      const { data, error } = await supabase?.rpc('get_audit_logs_paginated', {
        p_page: page,
        p_page_size: pageSize,
        p_action: action,
        p_table_name: tableName,
        p_user_id: userId,
        p_start_date: startDate,
        p_end_date: endDate
      });

      if (error) throw error;

      return {
        logs: data?.map(log => ({
          id: log?.id,
          userId: log?.user_id,
          userEmail: log?.user_email,
          userRole: log?.user_role,
          action: log?.action,
          tableName: log?.table_name,
          recordId: log?.record_id,
          oldData: log?.old_data,
          newData: log?.new_data,
          ipAddress: log?.ip_address,
          userAgent: log?.user_agent,
          metadata: log?.metadata,
          createdAt: log?.created_at
        })) || [],
        totalCount: data?.[0]?.total_count || 0
      };
    } catch (error) {
      console.error('Error fetching audit logs:', error);
      throw error;
    }
  },

  /**
   * Log authentication event
   */
  async logAuthEvent(userId, action, ipAddress = null, userAgent = null, metadata = {}) {
    try {
      const { data, error } = await supabase?.rpc('log_auth_event', {
        p_user_id: userId,
        p_action: action,
        p_ip_address: ipAddress,
        p_user_agent: userAgent,
        p_metadata: metadata
      });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error logging auth event:', error);
      throw error;
    }
  },

  /**
   * Get audit statistics
   */
  async getAuditStatistics(startDate = null, endDate = null) {
    try {
      let query = supabase?.from('audit_logs')?.select('action, table_name, created_at');

      if (startDate) {
        query = query?.gte('created_at', startDate);
      }
      if (endDate) {
        query = query?.lte('created_at', endDate);
      }

      const { data, error } = await query;

      if (error) throw error;

      // Calculate statistics
      const stats = {
        totalActions: data?.length || 0,
        actionsByType: {},
        actionsByTable: {},
        recentActivity: []
      };

      data?.forEach(log => {
        // Count by action type
        stats.actionsByType[log?.action] = (stats?.actionsByType?.[log?.action] || 0) + 1;
        
        // Count by table
        stats.actionsByTable[log?.table_name] = (stats?.actionsByTable?.[log?.table_name] || 0) + 1;
      });

      return stats;
    } catch (error) {
      console.error('Error fetching audit statistics:', error);
      throw error;
    }
  }
};